import { Button } from "@/components/ui/button";
import { useQueryWorkArea } from "modules/curb-zone/hooks/use-query-work-area";
import { Dispatch, SetStateAction, useState } from "react";
import { WorkArea } from "@/modules/curb-zone/components/work-area/work-area.type";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Checkbox } from "@/components/ui/checkbox";

interface WorkAreaDetailProps {
  workAreaDetail: WorkArea;
  setOpenWorkAreaModal: Dispatch<SetStateAction<boolean>>;
  setWorkAreaDetail: (params: WorkArea | undefined) => void;
}
export const WorkAreaDetail = ({ workAreaDetail, setOpenWorkAreaModal, setWorkAreaDetail }: WorkAreaDetailProps) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const handleEdit = () => setOpenWorkAreaModal(true);
  const { handleUpdateWorkArea, handleRemoveWorkArea } = useQueryWorkArea();
  const handleDelete = async () => {
    await handleRemoveWorkArea({ id: workAreaDetail.id });
    setOpenConfirm(false);
    setWorkAreaDetail(undefined);
  };

  const onChangeStatus = async (done: boolean) => {
    const updateWorkAreaParam = { workAreaInput: { ...workAreaDetail, done } };
    const response = await handleUpdateWorkArea(updateWorkAreaParam);
    if (response?.updateWorkArea) {
      setWorkAreaDetail(response.updateWorkArea);
    }
  };
  return (
    <>
      <div className="transition-opacity absolute h-auto top-36 bg-primary p-3 right-6 mt-2 mb-3 rounded-md shadow-lg z-5 min-w-80 max-w-100">
        <div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Name</span>
            <span className="text-sm text-secondary text-right">{workAreaDetail.name}</span>
          </div>
          <div className="flex justify-between w-full items-center py-2">
            <span className="text-sm text-secondary">Done</span>
            <div>
              <Checkbox checked={workAreaDetail.done} onCheckedChange={(value: boolean) => onChangeStatus(value)} />
            </div>
          </div>
        </div>
        <div className="flex justify-between mt-4">
          <Button variant="destructive" onClick={() => setOpenConfirm(true)}>
            Delete
          </Button>
          <Button variant="secondary" onClick={handleEdit}>
            Edit
          </Button>
        </div>
      </div>
      <AlertDialog open={openConfirm}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Delete work area</AlertDialogTitle>
            <AlertDialogDescription>Are you sure that you want to delete this work area?</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setOpenConfirm(false)}>Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={handleDelete}>Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
